import React, { useEffect, useRef, useState } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import { FormControl } from '@mui/material'
import Select, { MultiValue, SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { useTranslation } from 'react-i18next'
import '../../i18n'
import {
  getSecurityControls,
  getSecurityControlsbylistsecurity,
} from '../../redux/securityCheckFamily/securityCheckFamilyAction'
import { useSelector } from 'react-redux'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'

interface SelectSecurityCheckFamilyProps {
  value: string | string[]
  onChange: (event: SelectChangeEvent<string | string[]>) => void
  securityId: string | string[]
  multiple?: boolean
}

const SecurityControlsSelect: React.FC<SelectSecurityCheckFamilyProps> = ({
  value,
  onChange,
  securityId,
  multiple = true,
}) => {
  const menu = useExclusiveMenu()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const securityCheckFamilysList = useSelector(
    (state: RootState) => state.securitycheckFamily.SecurityControls
  )

  const containerRef = useRef<HTMLDivElement | null>(null)
  const [optionsLoading, setOptionsLoading] = useState(false)


  const SecurityIds = Array.isArray(securityId) ? securityId.join(',') : securityId

  useEffect(() => {
    if (!SecurityIds) {
      setOptionsLoading(false)
      return
    }
    let active = true
    setOptionsLoading(true)
    dispatch(getSecurityControlsbylistsecurity(SecurityIds)).finally(() => {
      if (active) setOptionsLoading(false)
    })
    return () => {
      active = false
    }
  }, [dispatch, SecurityIds])

  const options = securityCheckFamilysList
    ? securityCheckFamilysList.map((security) => ({
        value: security._id || '',
        label: security.Label || '',
      }))
    : []

  const selectedOptions = multiple
    ? options.filter((opt) => Array.isArray(value) && value.includes(opt.value))
    : options.find((opt) => opt.value === value) || null

  const handleSelectChange = (
    selected: MultiValue<{ value: string; label: string }> | SingleValue<{ value: string; label: string }>
  ) => {
    let newValue: string | string[] = ''
    if (multiple) {
      if (Array.isArray(selected)) {
        newValue = selected.map((s) => s.value)
      } else {
        newValue = []
      }
    } else {
      if (selected && !Array.isArray(selected)) {
        newValue = (selected as { value: string; label: string }).value
      } else {
        newValue = ''
      }
    }

    onChange({
      target: { name: 'SecurityCheckFamilyId', value: newValue },
    } as SelectChangeEvent<string | string[]>)
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      <FormControl sx={{ width: '100%' }}>
        <Select
          isMulti={multiple}
          value={selectedOptions}
          onChange={handleSelectChange}
          options={options}
          isLoading={optionsLoading}
          placeholder={optionsLoading ? t('selectOptions.loading') : t('Security Controls')}
          isDisabled={!securityId || optionsLoading}
          noOptionsMessage={() =>
            securityId
              ? t('No security check families available')
              : t('Please select a Security Check Family first')
          }
          {...menu}
          styles={incyiaSelectStyles}
        />
      </FormControl>
    </div>
  )
}

export default SecurityControlsSelect
